import { isEmbeddingAccepted } from "../../../consent";

export default class EventsMap {
    static init() {
        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            return;
        }

        let elements = document.querySelectorAll('neos-events');
        if (!elements.length) {
            return;
        }

        Array.from(elements).forEach(el => {
            new EventsMap(el);
        });
    }

    constructor(el) {
        const initialMessageEl = el.querySelector('.neos-events__initial-message');
        if (!initialMessageEl) {
            return;
        }

        if (!isEmbeddingAccepted('Google Maps')) {
            initialMessageEl.innerHTML = 'Bitte <a href="#CCM.openWidget">akzeptiere Google Maps im Cookie-Banner</a>, um die Event-Karte anzeigen zu können.';
            return;
        }

        const hasEventId = !!el.dataset.eventId;
        if (hasEventId) {
            initialMessageEl.innerHTML = 'Event wird geladen...';
            return;
        }

        initialMessageEl.innerHTML = 'Events-Übersicht wird geladen...';
    }
}
